<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>财务中心设置</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="公司名称"
                        prop="company_name">
            <el-input placeholder="请输入公司名称"
                      clearable
                      v-model="search.company_name"></el-input>
          </el-form-item>
          <el-form-item label="禁用状态"
                        prop="is_disabled">
              <el-select class="width-max"
                         clearable
                         v-model="search.is_disabled"
                         placeholder="请选择">
                <el-option
                  v-for="(value, key) in {0: '启用中', 1: '已禁用'}"
                  :key="key"
                  :label="value"
                  :value="key">
                </el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="开票信息ID"
                        prop="id">
            <el-input placeholder="请输入开票信息ID"
                      clearable
                      v-model="search.id"></el-input>
          </el-form-item>
          <el-form-item label="客户名称"
                        prop="customer_id">
            <remote-select v-model="search.customer_id"
                    placeholder="请输入关键词"
                    :queryRequest="(_)=>getCustomerTableForSearch(Object.assign(_, {type: 'all'}))"
                    :findRequest="getCustomerInfoRemote"
                    clearable
                    valueKey="id"
                    labelKey="name"
                    idKey="id">
            </remote-select>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button @click="resetSearch()">重置
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <router-link :to="'/customer-receipt/create'">
          <el-button type="primary"
                     icon="sj-icon-add"
                     size="small">添加客户开票信息
          </el-button>
        </router-link>
        <el-button type="primary"
                    icon="sj-icon-export"
                    @click="onExportSearch"
                    size="small">导出客户开票信息
        </el-button>
        <router-link :to="'/customer-receipt/batch/create'">
          <el-button type="primary"
                     icon="sj-icon-add"
                     size="small">批量添加客户开票信息
          </el-button>
        </router-link>
        <router-link :to="'/customer-receipt/batch/update'">
          <el-button type="primary"
                     icon="sj-icon-add"
                     size="small">批量更新客户开票信息
          </el-button>
        </router-link>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <template v-for="(attr, index) of fields">
          <el-table-column :key="index" v-bind="attr"></el-table-column>
        </template>
        <el-table-column fixed="right"
                         label="操作"
                         width="200">
          <template slot-scope="scope">
            <div class="button-gutter">
              <router-link :to="`/customer-receipt/detail/${scope.row.id}`">
                <el-button size="mini">查看</el-button>
              </router-link>
              <router-link :to="`/customer-receipt/update/${scope.row.id}`">
                <el-button size="mini"
                           type="primary">修改
                </el-button>
              </router-link>
              <el-button v-if="scope.row.is_disabled" type="primary"
                         size="mini"
                         @click="onEnable(scope.row.id)">启用
              </el-button>
              <el-button v-else type="danger"
                         size="mini"
                         @click="onDisable(scope.row.id)">禁用
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table-v3'
import customerReceiptMixins from '../customer-receipt.mixins'
import { searchRules } from '../customer-receipt.rules.js'

export default {
  mixins: [table, dateTimePicker, customerReceiptMixins],
  data () {
    return {
      searchRules,
      search: {
        id: null,
        company_name: null,
        customer_id: null,
        is_disabled: null,
      },
      exportHeader: [
        {
          key: 'id',
          text: '开票信息ID',
        },
        {
          key: 'company_name',
          text: '公司名称',
        },
        {
          key: 'bank_info',
          text: '开户银行及账户',
        },
        {
          key: 'address_phone',
          text: '地址及电话',
        },
        {
          key: 'tax_number',
          text: '税号',
        },
        // {
        //   key: 'customer_info',
        //   text: '使用客户名称/编号'
        // },
        {
          key: 'customer_ids',
          text: '使用客户ID'
        },
        {
          key: 'cond_ids',
          text: '账期ID'
        },
        // {
        //   key: 'cond_names',
        //   text: '账期名称'
        // },
        {
          key: 'is_disabled',
          text: '禁用状态',
        }
      ],
    }
  },
  computed: Vuex.mapState({}),
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map(['getCustomerTable', 'getCustomerTableForSearch']),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getCustomerReceiptTable', params)
    },
    onExportSearch () {
      this.$export('客户开票抬头信息导出', {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: params => request.page('exportCustomerReceiptTable', params),
        requestParams: this.search,
        getResponseData (data) {
          data.data.forEach(element => {
            element.is_disabled = !element.is_disabled ? '启用中' : '已禁用'
            let condNames = []
            element.cond_infos.forEach(item => {
              condNames.push(item['name'])
            })
            element.cond_names = condNames.join('、')
            element.cond_ids = element.pay_condition_ids.join('、')
          })
          return data
        },
      })
    },
    onExportRows (id) {
      this.$export(this.$route.meta.title, {
        type: 'array',
        request: (params) => request('exportCustomerReceiptData', params),
        requestParams: {id},
        getResponseData (data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1)
          return data
        },
      })
    },
    onEnable (id) {
      this.$confirm('是否启用该信息', '提示', {type: 'warning'}).then(() => {
        request.common('enableCustomerReceipt', {id}).then(() => {
          this.$message.success('启用成功')
          this.onRefresh()
        })
      })
    },
    onDisable (id) {
      this.$confirm('是否禁用该信息', '提示', {type: 'warning'}).then(() => {
        request.common('disableCustomerReceipt', {id}).then(() => {
          this.$message.success('禁用成功')
          this.onRefresh()
        })
      })
    },
    getCustomerInfoRemote (id) {
      return request.common('getCustomerDetail', id)
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/customer-receipt/pages/CustomerReceiptTable.vue